/**
 * Initializes contact form handlers and view updates.
 */
export function InitContactForm(){
	let $form = $('.contact-form form');

	if($form.length === 0)
		return;

	let $textSuccess = $('#contact-form-success');
	let $inputErrorFields = $form.find('.input-error');
	let $buttonSubmit = $('#button-submit-contact-form');
	let $spinner = $buttonSubmit.find('.animate-spin');

	$form.on('submit', function(event){
		event.preventDefault();
		let formData = $form.serialize();

		$textSuccess.toggleClass('hidden', true);
		$spinner.toggleClass('hidden', false);

		$.ajax({
			type: 'POST',
			url: $form.attr('action'),
			data: formData
		}).done(function(response) {
			$spinner.toggleClass('hidden', true);
			$textSuccess.toggleClass('hidden', false);
			$inputErrorFields.toggleClass('hidden', true);

			$form.find('input,textarea')
				.not(':button, :submit, :reset, :hidden')
				.val('')
				.prop('checked', false)
				.prop('selected', false);
		}).fail(function(data) {
			$spinner.toggleClass('hidden', true);
			$textSuccess.toggleClass('hidden', true);
			$inputErrorFields.toggleClass('hidden', true);

			Object.keys(data.responseJSON.error).forEach(function(key,index) {
				let error = data.responseJSON.error[key];
				var $input = $form.find('input[name="' + key + '"]');

				if($input.length === 0)
					$input = $form.find('input[name="' + key + '[]"]');

				if($input.length > 0)
					$input.closest('.form-field').find('.input-error').html(error).toggleClass('hidden', false);
			});
		});
	});
}